import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { Plane } from 'lucide-react'
import { prefersReducedMotion } from '@/lib/gsap'
import { DESTINATIONS, GLOBAL_COPY } from '@/constants/aerive'

const DestinationTicker: FC = (): ReactNode => {
    const [index, setIndex] = useState(0)

    useEffect(() => {
        if (prefersReducedMotion()) return
        const timer = window.setInterval(() => {
            setIndex((current) => (current + 1) % DESTINATIONS.length)
        }, 1900)
        return () => window.clearInterval(timer)
    }, [])

    return (
        <div className='flex flex-nowrap items-center justify-center gap-2 sm:gap-4 md:justify-start'>
            <span className='shrink-0 font-heading text-[1.3rem] leading-none text-ivory sm:text-[1.6rem] md:text-[1.8rem]'>{GLOBAL_COPY.kicker}</span>
            <span className='flex shrink-0 items-center gap-2 text-champagne'>
                <span className='h-px w-4 bg-champagne/50 sm:w-6 md:w-8' />
                <Plane className='size-4' aria-hidden='true' />
                <span className='h-px w-4 bg-champagne/50 sm:w-6 md:w-8' />
            </span>
            <span className='relative inline-flex h-[1.6rem] min-w-[6.5ch] shrink-0 items-center overflow-hidden sm:h-[1.9rem] md:h-[2.1rem]'>
                <span
                    key={DESTINATIONS[index]}
                    className='block whitespace-nowrap font-heading text-[1.3rem] leading-none text-champagne animate-in fade-in slide-in-from-bottom-4 duration-700 sm:text-[1.6rem] md:text-[1.8rem]'
                >
                    {DESTINATIONS[index]}
                </span>
            </span>
        </div>
    )
}

export default DestinationTicker
